module.exports = __webpack_public_path__ + "img/avatar7.7564ad32.png";